import { useState } from "react";
import { IoCloseSharp } from "react-icons/io5";

import FileBait from "./FileBait";
import LocalFileCard from "./LocalFileCard";
import Upload from "./Upload";
import * as UI from "../../../../../../modules/ui-kit";

export default function FileUpload(props) {
    const { brandID, children, disabled, onChange } = props;

    const [file, setFile] = useState<File>(undefined);

    function onUploaded(fileURL) {
        onChange(fileURL);
        setFile(undefined);
    }

    if (!brandID) {
        return (<span>You must select Brand to upload files.</span>);
    }

    if (file) {
        return (
            <LocalFileCard
                disabled={ disabled }
                file={ file }
            >
                <Upload
                    brandID={ brandID }
                    disabled={ disabled }
                    file={ file }
                    onUploaded={ onUploaded }
                />
                <UI.Button
                    onClick={ () => setFile(undefined) }
                >
                    <IoCloseSharp />
                </UI.Button>
            </LocalFileCard>
        );
    }

    return (
        <FileBait
            disabled={ disabled }
            onFile={ setFile }
        >
            { children }
        </FileBait>
    );
}
